

// instalar redux   npm i redux

/*
npm i redux
npm i react-redux
npm i redux-devtools-extension
npm i redux-thunk
npm i axios
*/

// pasos 


//constantes  almacenan la informacion

const dataInitial = {
  count: 0,
  autenticacion:[],
  imagen: [],
  portafolio :[]
};


//tipes  son como variables de entorno

const SET_PORTAFOLIO = 'SET_PORTAFOLIO'
const GET_PORTAFOLIO= 'GET_PORTAFOLIO'
const SET_PORTAFOLIO_SUCCES= 'SET_PORTAFOLIO_SUCCES'

//Reducer


export default function PortafolioAddReducer(state = dataInitial, action) {
  switch (action.type) {
    case SET_PORTAFOLIO:
      return { ...state, autenticacion:  action.payload };
      default:
      return state;
  }
}

//Acciones

export const PortafolioAdd = () => async ( dispatch , getState) => {
  
        dispatch({

          type: SET_PORTAFOLIO,
          payload:["admon"]
        })
 
};
